import { IMultiSelectOptions } from "@starrez/starryui";
import { v4 as uuidv4 } from "uuid";
import { IWizardExecuteDataModel } from "../../../components/Wizard";
import { mapEntryAddressTypeToItems, mapFromAddressTypeToItem } from "../../../context";
import { IAddressTypes } from "../../../context/AdvancedEmailWizardContext/graphQL/types";
import { IEmailTemplate } from "../../../data/graphQL/types";
import { IAttachmentFile, IAttachmentStatus, mapAttachmentFileToSimpleAttachments, mapTemplateAttachments } from "../../Steps/Attachments";
import { IEmailPreview } from "../../Steps/Preview/graphQL/emailPreview";

export interface IEmailDataModel extends IWizardExecuteDataModel {
    TemplateID: number;
    Attachments: IAttachmentFile[];
    AttachmentsCollection: IAttachmentStatus[];

    CorrespondenceName: string;
    EmailTo: Array<string | number>;
    EmailToItems: IMultiSelectOptions[];

    EmailFromID: number;
    EmailFromItem: IMultiSelectOptions | null;

    EmailCC: boolean;
    EmailCCAddress: Array<string | number>;
    EmailCCAddressItems: IMultiSelectOptions[];

    EmailBCC: boolean;
    EmailBCCAddress: Array<string | number>;
    EmailBCCAddressItems: IMultiSelectOptions[];

    CCAddressOnlyFirst: boolean;
    BCCAddressOnlyFirst: boolean;
    EmailSubject: string;
    EmailBody: string;
    ViewOnWeb: boolean;

    UnlayerTemplate?: {};

    CopyToCorrespondence: boolean;
    TemporaryAttachmentFolder: string;

    Preview?: IEmailPreview;
}

export const mapTemplateToEmailDataModel = (emailTemplate: IEmailTemplate, AddressTypes?: IAddressTypes): IEmailDataModel => {
    return {
        TemplateID: emailTemplate.id,
        Attachments: mapTemplateAttachments(emailTemplate.templateAttachments),
        AttachmentsCollection: [],

        EmailBody: emailTemplate.templateDetails?.emailBody || "",
        UnlayerTemplate: emailTemplate.templateDetails ? JSON.parse(emailTemplate.templateDetails?.unlayerJsonString as string) : undefined,

        CorrespondenceName: emailTemplate.templateDetails?.correspondenceName || "",
        EmailSubject: emailTemplate.templateDetails?.emailSubject || "",
        EmailTo: emailTemplate.templateDetails?.emailTo || [],
        EmailFromID: emailTemplate.templateDetails?.emailFromID || -1,
        EmailCC: emailTemplate.templateDetails?.emailCC || false,
        EmailCCAddress: emailTemplate.templateDetails?.emailCCAddress || [],
        EmailBCC: emailTemplate.templateDetails?.emailBcc || false,
        EmailBCCAddress: emailTemplate.templateDetails?.emailBccAddress || [],
        CCAddressOnlyFirst: emailTemplate.templateDetails?.cCAddressOnlyFirst || false,
        BCCAddressOnlyFirst: emailTemplate.templateDetails?.bCCAddressOnlyFirst || false,
        ViewOnWeb: emailTemplate.templateDetails?.viewOnWeb || false,
        CopyToCorrespondence: emailTemplate.templateDetails?.copyToCorrespondence || false,
        TemporaryAttachmentFolder: emailTemplate.templateDetails?.temporaryAttachmentFolder || `_attachments_${uuidv4()}`,

        EmailToItems: mapEntryAddressTypeToItems(AddressTypes?.entryAddressTypes, emailTemplate.templateDetails?.emailTo),
        EmailFromItem: mapFromAddressTypeToItem(AddressTypes?.fromAddresses, Number(emailTemplate.templateDetails?.emailFromID)),

        EmailCCAddressItems: mapEntryAddressTypeToItems(AddressTypes?.entryAddressTypes, emailTemplate.templateDetails?.emailCCAddress),
        EmailBCCAddressItems: mapEntryAddressTypeToItems(AddressTypes?.entryAddressTypes, emailTemplate.templateDetails?.emailBccAddress),

        transformData() {
            this.AttachmentsCollection = mapAttachmentFileToSimpleAttachments(this.Attachments);

            // Need to transform the selections to the model specification
            this.EmailBCCAddress = [];

            // To Addresses
            this.EmailTo = this.EmailToItems?.map((emailToItem) => emailToItem.value) ?? [];

            // From Address
            this.EmailFromID = this.EmailFromItem ? Number(this.EmailFromItem!.value) : -1;

            // CC/BCC
            this.EmailCCAddress = this.EmailCCAddressItems.map((emailCC) => emailCC.value);
            this.EmailBCCAddress = this.EmailBCCAddressItems.map((emailBCC) => emailBCC.value);
        },
    };
};
